<template>
  <div class="body">
    <CreateMomentIcon v-if="showBtn"></CreateMomentIcon>
    <LoadingComponent v-if="isLoading"></LoadingComponent>
    <div v-if="!isLoading">
      <div v-for="item in pageItemList" :key="item.id">
        <div v-if="item.unit_type === 2">
          <BannerList :bannerList="item.item" v-if="item.item && item.item.length > 0"></BannerList>
        </div>
        <div v-if="item.unit_type === 3">
          <MomentItemFeed :listType="item.item.list_type"></MomentItemFeed>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MomentItemFeed from "../../ugc_item/MomentItemFeed";
  import BannerList from "../../common/BannerList"
  import CreateMomentIcon from "../../common/CreateMomentIcon";
  import Loading from "cube-ui/src/components/loading/loading";
  import LoadingComponent from "../../common/LoadingComponent";

  export default {
    name: "MomentFeedPage",
    components: {
      LoadingComponent,
      Loading,
      CreateMomentIcon,
      MomentItemFeed,
      BannerList,
    },
    data() {
      return {
        showBtn: true,
        isLoading: true,

        pageItemList: [],
      }
    },

    mounted() {
      this.initFrontPage()
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll(event) {
        if (window.innerHeight + window.scrollY > document.body.clientHeight - 40) {
          this.showBtn = false
        } else {
          this.showBtn = true
        }
      },

      initFrontPage() {
        this.$store.dispatch("FeedMomentPage").then((data) => {
          if (data.code === 0) {
            this.pageItemList = data.data
            this.isLoading = false
          }
        }, () => {
        })
      },

    },
  };
</script>

<style lang="scss" scoped>
  .body {
    background: #f2f2f2;
    padding-top: 3px;
    padding-bottom: 55px;
    min-height: 100vh;
  }
</style>
